import {campaignApiUrl} from '../../appConfig';

/* Utils */
import {getAuthorizationHeaderWithBearer} from '../../common/network/apiUtils';

function campaignApiFactory(storefrontApiClient) {
  const campaignApi = {
    getCampaigns(params) {
      return storefrontApiClient.get('/allCampaigns', {
        params,
      });
    },

    getSpecialCampaigns(params) {
      return storefrontApiClient.post(
        `${campaignApiUrl}/Campaign/GetSpecialCampaignList`, {},
        {
          headers: {
            ...getAuthorizationHeaderWithBearer(params?.jwt),
          },
        }
      );
    },

    getCustomerSpecialCampaigns(params) {
      return storefrontApiClient.post(
        `${campaignApiUrl}/Campaign/getCustomerSpecialCampaign`, {
          product: {
            sku: params?.sku,
            merchantId: params?.merchantId,
          },
          platform: params?.platform,
        }, {
          headers: {
            ...getAuthorizationHeaderWithBearer(params?.jwt),
          },
        }
      );
    },
  };

  return campaignApi;
}

export default campaignApiFactory;
